module.exports = __webpack_public_path__ + "static/objective_waves-2318a11e4acb066f03f16f16be7f35e0.svg";